// extracted by mini-css-extract-plugin
export default {"container":"xJ-z","header":"yJ-z","details":"zJ-z","link":"AJ-z"};